import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanRequest } from 'src/model/loanRequest.model';
import { LoanRequestService } from 'src/services/loan-request.service';

@Component({
    selector: 'app-search-ticket',
    templateUrl: './search-ticket.component.html',
    styleUrls: ['./search-ticket.component.scss'],
    standalone: false
})
export class SearchTicketComponent {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private lrService = inject(LoanRequestService);

  ticketNumber: number;
  disabledSubmit = false;

  loanRequest: LoanRequest;
  relatedList: LoanRequest[] = [];
  relatedCustomerIds: number[] = [];
  isCollapsed = true;

  detectEnableSearch() {
    this.disabledSubmit = this.ticketNumber == null || String(this.ticketNumber) === '';
    return this.disabledSubmit;
  }

  async searchTicket() {
    this.loanRequest = undefined;
    if (this.ticketNumber == null || String(this.ticketNumber) === '')
      this.sharedService.openAlert("Please enter ticket number!", ALERT_TYPE.DANGER);
    else {
      this.loanRequest = await this.lrService.getLoanApprovalRequestById(this.ticketNumber);
      this.relatedList = (this.loanRequest.LoanGroupId != undefined) ? (await this.lrService.getLoanGroupApprovalRequests(this.loanRequest.LoanGroupId)).filter(r => r.ID != this.loanRequest.ID) : undefined;
      this.relatedCustomerIds = this.relatedList.map(r => Number(r.CustomerId)).concat(this.loanRequest.CustomerId);
    }
  }

  reset() {
    this.activeModal.close();
  }
}